<div class="row mt-4">
  <div class="col-md-12">
    <div class="row mb-3">
      <div class="col-3 mr-auto">
        <h3>Premium Service Meta</h3>
      </div>
      <div class="col-2 ml-auto">
        <label class="mb-0" for=""><u>Items Per Page</u></label>
        <select (change)="itemsPerPageChange($event.target.value)" class="form-control">
          <option *ngFor="let ipp of pagingList">{{ipp}}</option>
        </select>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <label for=""><u>Filter by Name</u></label>
        <input type="text" [(ngModel)]="filterable.name" class="form-control" placeholder="enter name" />
      </div>
      <div class="col ml-auto text-right  align-self-end">
        <button class="btn btn-primary btn-sm mr-2" (click)="search()">Search</button>
        <button class="btn btn-danger btn-sm mr-2" (click)="clear()">Clear</button>
        <button class="btn btn-outline-success btn-sm text-dark font-weight-bold" (click)="openModal(newMetaModel)" *ngIf="currentUser.roleName == 'ADMIN'">+ Meta </button>
      </div>
    </div>
  </div>
</div>
<div class="mt-3 mb-2 row">
  <div class="col-2 align-self-center">
    Total Results: {{totalItems}}
  </div>
</div>
<table id="spiderList" class="table table-striped table-bordered mt-3 text-center" style="width:100%">
  <thead>
    <tr>
      <th>No.</th>
      <th>Name</th>
      <th>Description</th>
      <th>Created At</th>
      <th>Operate</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngIf="loading">
      <td colspan="16">
        <div class="loader">Loading...</div>
      </td>
    </tr>
    <tr *ngIf="emptyResult">
      <td colspan="16">
        <div class="alert alert-warning">Empty Result...</div>
      </td>
    </tr>
    <tr *ngFor="let meta of metas; index as i;">
      <td>{{i + 1}}</td>
      <td>{{meta.name}}</td>
      <td>{{meta.description}}</td>
      <td>{{meta.createdAt | date: 'medium'}}</td>
      <td>
        <button type="button" class="btn btn-sm btn-primary mr-2 mt-2" placement="top" ngbTooltip="View & Edit" (click)="openModal(newMetaModel, meta)" *ngIf="currentUser.roleName == 'ADMIN'">
          <i class="fas fa-pen"></i>
        </button>
        <button type="button" class="btn btn-sm btn-danger mr-2 mt-2" placement="top" ngbTooltip="Delete" (click)="deleteMeta(meta)" *ngIf="currentUser.roleName == 'ADMIN'">
          <i class="fas fa-trash"></i>
        </button>
      </td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <td colspan="16" *ngIf="!loading && !emptyResult">
        <pagination [totalItems]="totalItems" [itemsPerPage]="itemsPerPage" [(ngModel)]="currentPage" [maxSize]="maxSize" class="pagination-md mb-0 justify-content-center" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;"
          lastText="&raquo;" [boundaryLinks]="true" [rotate]="false" (numPages)="numPages = $event" (pageChanged)="pageChanged($event)"></pagination>
        <!-- <button (click)="setPage(2)">GO TO PAGE</button> -->
      </td>
    </tr>
  </tfoot>
</table>
<!-- </div> -->

<ng-template #newMetaModel let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="newMetaLabel">Add/Edit Meta</h5>
    <button type="button" class="close" (click)="modal.dismiss()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" id="newMeta-modal-body">
    <form [formGroup]="newMeta" (ngSubmit)="onSubmit()">
      <small><i class="text-danger">* indicates mandatory field</i></small>
      <div class="form-group row p-2">
        <div class="col-sm-12">
          <label for="name" class="col-form-label"><span class="text-danger">* </span>Name: </label>
          <input type="text" class="form-control" formControlName="name" placeholder="Name">
          <div class="text-danger small" *ngIf="showError">
            <div *ngIf="f.name.errors">
              The name cannot be blank.
            </div>
          </div>
          <label for="name" class="col-form-label">Description: </label>
          <input type="text" class="form-control" formControlName="description" placeholder="Description">
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
        <button type="submit" class="btn btn-primary" *ngIf="!processing">Save Meta</button>
        <button type="submit" class="btn btn-primary" *ngIf="processing" disabled>Processing..</button>
      </div>
    </form>
  </div>
</ng-template>
